import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class SegmentosService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  get() {
    return this.http
      .get(this.UrlService + "segmentos")
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  getSegmentosEmpresa(id: number) {
    return this.http
      .get(this.UrlService + `segmentos/${id}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  removerVinculos(id: number) {
    return this.http
      .delete(this.UrlService + `segmentos/removerVinculos/${id}`)
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  possuiComercioVeiculos() {
    return this.http
      .get(this.UrlService + 'segmentos/PossuiComercioVeiculos')
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }

  possuiUnidadeConsumo() {
    return this.http
      .get(this.UrlService + 'segmentos/PossuiUnidadeConsumo')
      .pipe(map((res: any) => res.data)
        , catchError(super.serviceError));
  }
}